import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(historyIssueListCompanyRoute);

    /** @ngInject */
    function historyIssueListCompanyRoute($stateProvider) {
        $stateProvider
            .state('company_employee.history_issue_list', {
                url: '/historia',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/company_issue_list/history/history.html'),
                controller: 'IssuesHistoryEmployeeController',
                controllerAs: 'IssuesHistoryEmployeeCtrl',
            })
            .state('company_employee.history_issue_list.issue_view', {
                url: '/:issue_id/',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/company_issue_list/details/issue_details.html'),
                controller: 'IssueDetailsCompanyController',
                controllerAs: 'IssueDetailsCompanyCtrl',
            });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/history/history.route.ts